/**
 * @generated SignedSource<<50a319fd858cd28edbfd7b1f1563945d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EditSubscriptionAmountOverrideDialogSubscriptionsQuery$variables = {
  searchTerm: string;
};
export type EditSubscriptionAmountOverrideDialogSubscriptionsQuery$data = {
  readonly subscriptions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly customerAccount: {
          readonly customerName: string;
        };
        readonly id: string;
        readonly state: string;
        readonly subscriptionServiceReferenceLabel: string | null | undefined;
      } | null | undefined;
    }>;
  } | null | undefined;
};
export type EditSubscriptionAmountOverrideDialogSubscriptionsQuery = {
  response: EditSubscriptionAmountOverrideDialogSubscriptionsQuery$data;
  variables: EditSubscriptionAmountOverrideDialogSubscriptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Variable",
    "name": "searchTerm",
    "variableName": "searchTerm"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "ORDERED_AT_DESC"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionServiceReferenceLabel",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditSubscriptionAmountOverrideDialogSubscriptionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SubscriptionConnection",
        "kind": "LinkedField",
        "name": "subscriptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SubscriptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Subscription",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomerAccount",
                    "kind": "LinkedField",
                    "name": "customerAccount",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditSubscriptionAmountOverrideDialogSubscriptionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SubscriptionConnection",
        "kind": "LinkedField",
        "name": "subscriptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SubscriptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Subscription",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomerAccount",
                    "kind": "LinkedField",
                    "name": "customerAccount",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f82b70b9a40abb627c7448439d36ed7b",
    "id": null,
    "metadata": {},
    "name": "EditSubscriptionAmountOverrideDialogSubscriptionsQuery",
    "operationKind": "query",
    "text": "query EditSubscriptionAmountOverrideDialogSubscriptionsQuery(\n  $searchTerm: String!\n) {\n  subscriptions(searchTerm: $searchTerm, first: 100, sort: ORDERED_AT_DESC) {\n    edges {\n      node {\n        id\n        state\n        subscriptionServiceReferenceLabel\n        customerAccount {\n          customerName\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4bed69166ebe2b0ba9cefaa7f9a3611e";

export default node;
